module.exports = __webpack_public_path__ + "img/ps-22.e924f2fc.jpg";